import CreditVoucher from "./CreditVoucher";

export default CreditVoucher;